import React, { useState } from 'react';
import { 
    Box, 
    Card, 
    CardContent, 
    TextField, 
    Button, 
    Typography, 
    Alert,
    CircularProgress,
    Container
} from '@mui/material';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth, getPasswordResetActionSettings } from '../firebase';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function PasswordReset() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');

        try {
            // Use centralized action settings
            const actionCodeSettings = getPasswordResetActionSettings();
            console.log('Action code settings:', actionCodeSettings);
            
            await sendPasswordResetEmail(auth, email, actionCodeSettings);
            setMessage('Passwort-Reset-E-Mail wurde gesendet! Bitte überprüfen Sie Ihr E-Mail-Postfach.');
        } catch (error) {
            console.error('Reset error:', error);
            switch (error.code) {
                case 'auth/user-not-found':
                    setError('Kein Benutzer mit dieser E-Mail-Adresse gefunden.');
                    break;
                case 'auth/invalid-email':
                    setError('Ungültige E-Mail-Adresse.');
                    break;
                case 'auth/too-many-requests':
                    setError('Zu viele Anfragen. Bitte warten Sie einen Moment.');
                    break;
                default:
                    setError('Fehler beim Senden der Reset-E-Mail. Bitte versuchen Sie es erneut.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container component="main" maxWidth="sm">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Card sx={{ width: '100%', maxWidth: 400 }}>
                    <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Button
                                startIcon={<ArrowBackIcon />}
                                onClick={() => navigate('/')}
                                sx={{ mr: 2 }}
                            >
                                Zurück
                            </Button>
                            <Typography component="h1" variant="h5">
                                Passwort zurücksetzen
                            </Typography>
                        </Box>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.
                        </Typography>

                        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="E-Mail-Adresse"
                                name="email"
                                autoComplete="email"
                                autoFocus
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={loading}
                            />

                            {error && (
                                <Alert severity="error" sx={{ mt: 2 }}>
                                    {error}
                                </Alert>
                            )}

                            {message && (
                                <Alert severity="success" sx={{ mt: 2 }}>
                                    {message}
                                </Alert>
                            )}

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                disabled={loading || !email}
                            >
                                {loading ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    'Reset-Link senden'
                                )}
                            </Button>

                            <Box sx={{ textAlign: 'center', mt: 2 }}>
                                <Button
                                    variant="text"
                                    onClick={() => navigate('/')}
                                    disabled={loading}
                                >
                                    Zurück zur Anmeldung
                                </Button>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
}
